__turbopack_context__.v({
  "buttonsWrapper": "shzLYq_buttonsWrapper",
  "content": "shzLYq_content",
  "details": "shzLYq_details",
  "detailsLabel": "shzLYq_detailsLabel",
  "detailsValue": "shzLYq_detailsValue",
  "iconWrapper": "shzLYq_iconWrapper",
  "wrapper": "shzLYq_wrapper",
});
